import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class AlreadyExistsError extends CodedError {
  static get errorName() {
    return errorCodes.alreadyExistsError.code;
  }

  constructor(message: string = errorCodes.alreadyExistsError.message) {
    super(message);
    this.code = errorCodes.alreadyExistsError.code;
    this.message = `${message} ${errorCodes.alreadyExistsError.code}`;
    this.name = errorCodes.alreadyExistsError.name;
  }
}
